import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProductService } from 'app/core/product/product.service';
import { InitialData } from 'app/modules/admin/manage-product/product-details/product-detail.types';

@Injectable({
    providedIn: 'root'
})
export class ProductDetailDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _productService: ProductService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot): Observable<InitialData> {
        return this._productService.getProductDetails(route.params['id'])
            .pipe(
                map((productDetails) => ({
                    productDetails
                })
                ),
                catchError(err => {
                    this._productService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().productDetails);
                })
            );
    }

}
class DefaultResponse implements InitialData {
    productDetails: any = [];
}